/* eslint-disable */
import 'jquery.cookie';
import ls from 'local-storage';
import moment from 'moment';

import wildcardDomain from '@/js/common/Domain/Service/wildcardDomain';
import toSearchHistoryLocalStorageTourCriteriaHydrator
    from '@/js/common/Domain/Hydrator/toSearchHistoryLocalStorageTourCriteria';

const localStorageKey = 'tr_searchHistory';

const searchHistoryPrivate = {
    checkExpired(searchCriteria) {
        const currentDate = moment();

        return moment(searchCriteria.checkInDateRange.from, 'DD.MM.YYYY') > currentDate;
    },
    getActualHistory() {
        const historyFromLocalStorage = ls.get(localStorageKey);

        return historyFromLocalStorage ? _.filter(historyFromLocalStorage, this.checkExpired) : [];
    },
    makeDescription(searchData) {
        let description = '';
        const hotels = searchData.get('hotels');
        const resorts = searchData.get('resorts');
        const countries = searchData.get('countries');

        if (hotels && hotels.length) {
            description = `${hotels.pluck('name').join(', ')}, `;
        } else if (resorts && resorts.length) {
            description = `${resorts.pluck('name').join(', ')}, `;
        }

        description += countries.pluck('name').join(', ');

        return description;
    },
    saveToLocalStorage(searchData) {
        const localStorageSearches = this.getActualHistory();
        const searchDataForLocalStorage = toSearchHistoryLocalStorageTourCriteriaHydrator(searchData);
        const search = _.find(localStorageSearches, localStorageSearch => _.isEqual(localStorageSearch, searchDataForLocalStorage));
        const searchIndex = localStorageSearches.indexOf(search);

        searchDataForLocalStorage.description = this.makeDescription(searchData);

        if (search) {
            localStorageSearches.splice(searchIndex, 1);
        }

        localStorageSearches.unshift(searchDataForLocalStorage);

        ls.set(localStorageKey, localStorageSearches);
    },
    saveLastSearch(searchData) {
        const searchDataForLocalStorage = toSearchHistoryLocalStorageTourCriteriaHydrator(searchData);

        $.cookie('last_search_criteria', JSON.stringify(searchDataForLocalStorage), {
            domain: wildcardDomain(),
            expires: 1,
            path: '/',
        });
    },
};

export default {
    addSearch: (searchData) => {
        searchHistoryPrivate.saveToLocalStorage(searchData);
        searchHistoryPrivate.saveLastSearch(searchData);
    },
    getLastSearches: () => searchHistoryPrivate.getActualHistory(),
    saveLastSearch: searchData => searchHistoryPrivate.saveLastSearch(searchData),
};